import classNames from 'clsx';
import React from 'react';

import { CasinoGameInfoCardMax } from '@swf/casino';
import PageNotFound from '@swf/components/PageNotFound/PageNotFound';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { CasinoGame } from '@swf/core/types/CasinoGame';

import styles from './CasinoGameInfo.scss';

interface LocationStateProps {
  game: CasinoGame;
  raceId?: string;
  fsbLaunch?: boolean;
}

const CasinoGameInfo: React.FC = () => {
  const { game, raceId, fsbLaunch, ...rest } = useSearchParams<LocationStateProps>();

  return (
    <div className={classNames(styles.container)}>
      {!game ? (
        <PageNotFound isModal />
      ) : (
        <CasinoGameInfoCardMax
          isModal
          game={game}
          fsbLaunch={fsbLaunch}
          raceId={raceId}
          {...rest}
        />
      )}
    </div>
  );
};

export default CasinoGameInfo;
